<template>
  <a class="affair_card_a" :href="itemHref" target="_blank" v-if="item != null">
    <div class="affair_card_outer">
      <img :src="imageSrc">
      <div class="affair_card_title">{{itemTitle}}</div>
      <div class="affair_card_desc">
        <div hidden="true">{{itemDesc}}</div>
        <div>{{itemDate}}</div>
      </div>
    </div>
  </a>
</template>

<script>
  /*
  *
        "actionTitle": "string",
        "classContentId": 0,
        "classGroupId": 0,
        "classId": 0,
        "content": "string",
        "createTime": "2021-02-20T06:44:42.482Z",
        "geoHash": "string",
        "id": 0,
        "imageUrls": "string",
        "isDel": 0,
        "lat": 0,
        "lng": 0,
        "newsId": 0,
        "newsTitle": "string",
        "newsUrl": "string",
        "originalContent": "string",
        "pointName": "string",
        "score": 0,
        "teamId": 0,
        "topicIds": "string",
        "trainingId": 0,
        "trainingOrderId": 0,
        "trainingTitle": "string",
        "trainingType": 0,
        "type": 0,
        "userId": 0
  *
  * */
export default {
  name: "HomeAffairCard",
  props: {
    item: {
      type: Object,
      value: null,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    imageSrc() {
      return this.item.imageUrls;
    },
    itemTitle() {
      return this.item.actionTitle;
    },
    itemDesc() {
      return '上海市徐汇区|赛事'
    },
    itemDate() {
      let createDate = this.$moment(this.item.createTime);
      if (createDate.isValid()) {
        return createDate.format('yyyy.MM.DD');
      }
      return '';
    },
    itemHref() {
      let newUrl = this.item.newsUrl;
      if (newUrl != null && newUrl.length > 0) {
        return newUrl;
      }
      return '/news/0302/detail/' + this.item.id;
    }
  },
  mounted() {
 //   console.log(this.item);
  }
}
</script>

<style scoped>
  .affair_card_a {
    text-decoration: none;
  }

  .affair_card_outer {
    width: 100%;
    /*height: 150px;*/
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
  }

  .affair_card_outer > img {
    width: auto;
    max-width: 100%;
    height: auto;
  }

  .affair_card_title {
    font-size: 15px;
    height: 42px;
    margin-top: 15px;
    text-align: left;
    padding-left: 2px;
    padding-right: 2px;
    color: black;

    letter-spacing: 1.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

  }

  .affair_card_title:hover {
    color: #333;
  }

  .affair_card_desc {
    font-size: 15px;
    color: #999;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    padding-left: 2px;
    padding-right: 2px;
    margin-top: 20px;
  }



</style>



// WEBPACK FOOTER //
// src/components/HomeAffairCard.vue